module.exports = __webpack_public_path__ + "img/Isochrone_scheme.81001c46.svg";